import ModalSwitch from './ModalSwitch';
export default ModalSwitch;
export { default as Modal } from './Modal';
export { default as ModalLink } from './ModalLink';
